import { LOCAL_STORAGE_HVM_USERINFO } from "@/lib/Constant";

export const getUserInfo = () => {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO)) || {};
}

export const isAuthenticated = () => {
    return !!getUserInfo().token;
};

export const getAccessToken = () => {
    return getUserInfo().token || "";
};

export const getUserUuid = () => {
    return getUserInfo().userUuid || "";
};

export const getUserId = () => {
    return getUserInfo().userId || "";
}

export const getUserName = () => {
    return getUserInfo().userName || "";
}